import { render, staticRenderFns } from "./GjwTableOperate.vue?vue&type=template&id=e4c43064&scoped=true"
import script from "./GjwTableOperate.vue?vue&type=script&lang=js"
export * from "./GjwTableOperate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c43064",
  null
  
)

export default component.exports